import { TranslationKeys } from './types';

const getTranslations = async (language: string): Promise<TranslationKeys> => {
  const translations = await import(`../../translations/${language}`);
  return translations.default;
};

export default getTranslations;
